import GlobalStyles from './styles/GlobalStyles';
import createTheme from './styles/theme';
import { commonInitApp } from 'common-embedded';
import { CURRENCIES, CURRENCY_SYMBOL } from 'common-ui/src/utils/constants';

const brandObject = {
  country: 'au',
  brandId: 'vir',
  currencyCode: CURRENCIES.AUD,
  currency: CURRENCY_SYMBOL.AUD,
};

const initApp = commonInitApp({ brandObject, createTheme, GlobalStyles });

export default initApp;